import { useState } from 'react';
import { PurchaseBillList } from '../components/PurchaseBillList';
import { CreditNotesList } from '../components/CreditNotesList';
import { PaymentList } from '../components/PaymentList';
import { ModuleGuide } from '@/shared/components/ui/ModuleGuide';
import { CommercialDocumentsList } from '../components/CommercialDocumentsList';
import { RecurringProfilesList } from '../components/RecurringProfilesList';

const TABS = [
  { id: 'purchase-orders', label: 'Purchase Orders' },
  { id: 'bills', label: 'Purchase Bills' },
  { id: 'recurring-bills', label: 'Recurring Bills' },
  { id: 'debit-notes', label: 'Debit Notes' },
  { id: 'payments', label: 'Vendor Payments' },
];

export function PurchasesPage() {
  const [tab, setTab] = useState('bills');

  return (
    <div className="p-6 space-y-4">
      <div>
        <h1 className="text-2xl font-semibold tracking-tight">Purchases</h1>
        <p className="text-sm text-muted-foreground mt-1">Bills, debit notes and vendor payments</p>
      </div>
      <ModuleGuide
        summary="A vendor bill creates a payable liability for the company; recording a payment reduces both the payable and the bank/cash balance."
        steps={['Select the vendor and save the purchase bill as a draft.', 'Finalize/post the bill → records expense/stock value and the vendor payable.', 'Post a vendor payment → reduces the payable due and the selected bank/cash balance.']}
        formulas={[
          { label: 'Bill total', formula: 'Taxable value + Input GST − Discount' },
          { label: 'Vendor due', formula: 'Posted bills − Payments − Debit notes' },
        ]}
      />
      <div className="flex gap-2 border-b">
        {TABS.map(t => (
          <button key={t.id} onClick={() => setTab(t.id)}
            className={`px-4 py-2 text-sm font-medium border-b-2 transition-colors ${tab === t.id ? 'border-primary text-primary' : 'border-transparent text-muted-foreground hover:text-foreground'}`}>
            {t.label}
          </button>
        ))}
      </div>
      {tab === 'bills' && <PurchaseBillList />}
      {tab === 'recurring-bills' && <RecurringProfilesList kind="bill" />}
      {tab === 'purchase-orders' && <CommercialDocumentsList collection="purchase-orders" />}
      {tab === 'debit-notes' && <CreditNotesList type="debit" />}
      {tab === 'payments' && <PaymentList initialTab="payment" />}
    </div>
  );
}
